export const VALID_RANDOMISATION_FACETS = [
  'bkg',
  'id',
  'dax',
  'mex',
  'mem',
  'mes',
  'meu',
  'pax',
  'sui',
  'sid',
  'tag',
  'tex',
  'vhp',
];
